var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContactsMain = function SvgContactsMain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-4);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 49.1,
    y1: 241.9,
    x2: 182.5,
    y2: 40.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 56.5,
    y1: 246.8,
    x2: 189.9,
    y2: 45,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 25,
    y1: 225.9,
    x2: 158.4,
    y2: 24.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 23.8,
    y1: 225.2,
    x2: 157.2,
    y2: 23.4,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M148.5,132.2h-57.7c-1.6,0-2.9,1.3-2.9,2.9s1.3,2.9,2.9,2.9h57.7c1.6,0,2.9-1.3,2.9-2.9s-1.3-2.9-2.9-2.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M148.5,148.2h-57.7c-1.6,0-2.9,1.3-2.9,2.9s1.3,2.9,2.9,2.9h57.7c1.6,0,2.9-1.3,2.9-2.9s-1.3-2.9-2.9-2.9Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M151.5,57c0-6.1-5-11.1-11.1-11.1h-41.4c-6.1,0-11.1,5-11.1,11.1v2.6c0,1.6,1.3,2.9,2.9,2.9s2.9-1.3,2.9-2.9v-2.6c0-2.9,2.3-5.2,5.2-5.2h41.4c2.9,0,5.2,2.3,5.2,5.2v43c-3.5-4.3-8-7.7-13.2-9.9,2-2.6,3.2-5.9,3.2-9.5,0-8.8-7.1-15.9-15.9-15.9s-15.9,7.1-15.9,15.9,1.2,6.8,3.2,9.5c-5.2,2.1-9.7,5.6-13.2,9.9v-26.8c0-1.6-1.3-2.9-2.9-2.9s-2.9,1.3-2.9,2.9v35.1c0,6.1,5,11.1,11.1,11.1h41.4c6.1,0,11.1-5,11.1-11.1v-51.4ZM119.7,70.6c5.5,0,10,4.5,10,10s-4.5,10-10,10-10-4.5-10-10,4.5-10,10-10ZM140.4,113.5h-41.4c-2.1,0-3.8-1.2-4.7-3,3.2-7.8,9.7-13.7,17.8-16.1,2.3,1.3,4.9,2,7.6,2s5.4-.7,7.6-2c8.1,2.3,14.6,8.2,17.8,16.1-.8,1.7-2.6,3-4.7,3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M179.8,165.4c1.6,0,2.9-1.3,2.9-2.9V11.2c0-6.2-5-11.2-11.2-11.2H42.8c-6.2,0-11.2,5-11.2,11.2v9.6h-4.5c-5.5,0-9.9,4.4-9.9,9.9s4.4,9.9,9.9,9.9h4.5v14.9h-4.5c-5.5,0-9.9,4.4-9.9,9.9s4.4,9.9,9.9,9.9h4.5v14.9h-4.5c-5.5,0-9.9,4.4-9.9,9.9s4.4,9.9,9.9,9.9h4.5v14.9h-4.5c-5.5,0-9.9,4.4-9.9,9.9s4.4,9.9,9.9,9.9h4.5v14.9h-4.5c-5.5,0-9.9,4.4-9.9,9.9s4.4,9.9,9.9,9.9h4.5v9.6c0,6.2,5,11.2,11.2,11.2h128.7c6.2,0,11.2-5,11.2-11.2v-12.6c0-1.6-1.3-2.9-2.9-2.9s-2.9,1.3-2.9,2.9v12.6c0,3-2.4,5.4-5.4,5.4h-104.2V5.9h104.2c3,0,5.4,2.4,5.4,5.4v151.2c0,1.6,1.3,2.9,2.9,2.9ZM23.1,30.7c0-2.2,1.8-4,4-4h14.8c2.2,0,4,1.8,4,4s-1.8,4-4,4h-14.8c-2.2,0-4-1.8-4-4ZM23.1,65.3c0-2.2,1.8-4,4-4h14.8c2.2,0,4,1.8,4,4s-1.8,4-4,4h-14.8c-2.2,0-4-1.8-4-4ZM23.1,100c0-2.2,1.8-4,4-4h14.8c2.2,0,4,1.8,4,4s-1.8,4-4,4h-14.8c-2.2,0-4-1.8-4-4ZM23.1,134.7c0-2.2,1.8-4,4-4h14.8c2.2,0,4,1.8,4,4s-1.8,4-4,4h-14.8c-2.2,0-4-1.8-4-4ZM23.1,169.3c0-2.2,1.8-4,4-4h14.8c2.2,0,4,1.8,4,4s-1.8,4-4,4h-14.8c-2.2,0-4-1.8-4-4ZM61.5,194.1h-18.7c-3,0-5.4-2.4-5.4-5.4v-9.6h4.5c5.5,0,9.9-4.4,9.9-9.9s-4.4-9.9-9.9-9.9h-4.5v-14.9h4.5c5.5,0,9.9-4.4,9.9-9.9s-4.4-9.9-9.9-9.9h-4.5v-14.9h4.5c5.5,0,9.9-4.4,9.9-9.9s-4.4-9.9-9.9-9.9h-4.5v-14.9h4.5c5.5,0,9.9-4.4,9.9-9.9s-4.4-9.9-9.9-9.9h-4.5v-14.9h4.5c5.5,0,9.9-4.4,9.9-9.9s-4.4-9.9-9.9-9.9h-4.5v-9.6c0-3,2.4-5.4,5.4-5.4h18.7v188.3Z"
  })));
};
export default SvgContactsMain;